<template>
    <div id="app">
        <router-view/>
    </div>
</template>
<script>
import VConsole from 'vconsole'

export default {
    mounted () {
        console.log('process.env.VUE_APP_FLAG', process.env.VUE_APP_FLAG)
        const vConsole = new VConsole({
            onReady: () => {
                console.log('process.env.VUE_APP_FLAG', process.env.VUE_APP_FLAG)
                if (process.env.VUE_APP_FLAG !== 'pro') {
                    vConsole.showSwitch()
                } else {
                    vConsole.hideSwitch()
                }
            }
        })
    }
}
</script>

<style lang="less">
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    #nav {
        padding: 30px;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }

    .disable-select {
        -moz-user-select: none;/*火狐*/
        -webkit-user-select: none;/*webkit浏览器*/
        -ms-user-select: none;/*IE10*/
        -khtml-user-select: none;/*早期浏览器*/
        user-select: none;
    }
</style>
